import type {
  MismatchStatus,
  PendingCountDto,
  ResolveMismatchRequest,
  Transaction,
  TransactionMismatchDto,
} from "@boo/shared";
import { request } from "./apiClient";

/** Count of pending (unresolved) reconciliation mismatches for the current user. */
export async function fetchPendingCount(): Promise<number> {
  const result = await request<PendingCountDto>(
    "/reconciliation/pending-count",
  );
  return result.count;
}

/** Pending mismatches for the current user (PDF snapshot vs current data). */
export async function fetchMismatches(): Promise<TransactionMismatchDto[]> {
  return request<TransactionMismatchDto[]>("/reconciliation/mismatches");
}

/** Resolve a single mismatch. `editedData` is only used for EDIT_MANUAL. */
export async function resolveMismatch(
  id: string,
  action: MismatchStatus,
  editedData?: Partial<Transaction>,
): Promise<void> {
  const body: ResolveMismatchRequest = { action, editedData };
  await request(`/reconciliation/mismatches/${id}/resolve`, {
    method: "PATCH",
    data: body,
  });
}
